import { Utilities } from "../../shared/utilities";
import { IAppReducerAction, IAppReducerOwnState } from "../shared/model";

const SET_ENVIRONMENTS = "SET_ENVIRONMENTS";
const SET_ISLOADING = "SET_ISLOADING";

const GET_ENVIRONMENTS = "GET_ENVIRONMENTS";

export const initialState: IAppReducerOwnState = {
    environments: [],
    isLoading: true,
    userPermissions: Utilities.getAllUserPermissions(),
};

export function reducer(state: IAppReducerOwnState, action: IAppReducerAction) {
    switch (action.type) {
        case SET_ENVIRONMENTS:
            return {
                ...state,
                environments: action.environments
            };
        case GET_ENVIRONMENTS:
            return {
                ...state,
                environments: state.environments
            };
        case SET_ISLOADING: 
            return {
                ...state,
                isLoading: action.isLoading
            }
        default:
            return initialState;
    }
}
